import { useTranslations } from "next-intl";
import Danger from "@/assets/icons/danger.svg";
import { cn } from "@/lib/utils";

export const DietMenuModalAllergensAlert = ({
  className,
  allergens,
}: {
  className?: string;
  allergens: string[] | undefined;
}) => {
  const t = useTranslations("diets");

  const allergensList =
    allergens && allergens.length > 0 ? allergens.join(", ") : t("noAllergens");
    
  return (
    <div
      className={cn(
        "flex items-start gap-2 rounded-b-xl bg-brand-yellow-lighter font-medium md:items-center",
        className
      )}
    >
      <Danger className="size-6 shrink-0" />
      <p className="font-normal text-brand-yellow-darker text-sm">
        <span className="font-medium">{t("allergens")}: </span>
        {allergensList}
      </p>
    </div>
  );
};
